const config = {
  name: "Esperi",
  pageTitle: "Esperi Lääkelupa",
  brandMainColor: "#ED1B24",
  language: "fi_FI",
  // serverUrl: "http://localhost:7071",
  // serverUrl: "https://fadevesperimedication.azurewebsites.net", // DEV
  serverUrl: "https://prod-laakelupa-api-fa.azurewebsites.net", // PROD
  systemMaintenanceMode: false, // Set to true to enable system-wide maintenance mode (blocks everyone including admins)
  routes: {
    main: "etusivu",
    form: "hakemus",
    doctorMain: "laakari-etusivu",
    doctorApproval: "laakari-hakemus",
    profile: "profiili",
    admin: "admin",
  },
};

export default config;
